import { signOut } from '@backoffice-frontend/authentication'
import { LOGIN_INTENDED_PATH } from '@backoffice-frontend/common'
import { MoiaLogo } from '@backoffice-frontend/patterns'
import { Button, Callout, Card, Text } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'
import store from 'store'

type WrongSubdomainViewProps = {
  expectedUrl?: string
}

export const WrongSubdomainView = ({
  expectedUrl,
}: WrongSubdomainViewProps) => {
  const { t } = useTranslation()

  // Sign out must never depend on resolving the URL, otherwise a failed lookup
  // leaves the user on a screen with no way out.
  const handleSignOut = async () => {
    store.remove(LOGIN_INTENDED_PATH)
    await signOut()
  }

  return (
    <>
      <title>{t('authenticatedAppView_wrongSubdomain_title')}</title>
      <div
        css={{
          minHeight: '100vh',
          backgroundSize: 'cover',
          alignItems: 'flex-start',
          justifyItems: 'center',
          backgroundImage: 'url(/assets/images/login.png)',
          display: 'grid',
        }}
      >
        <MoiaLogo
          css={theme => ({
            width: '160px',
            marginTop: theme.space.Space6,
            color: theme.palette.common.white,
          })}
        />
        <Card
          css={theme => ({
            padding: theme.space.Space3,
            width: '400px',
            display: 'flex',
            flexDirection: 'column',
            gap: theme.space.Space2,
          })}
          outline
        >
          <Callout variant="warning" hideDismiss>
            <Text>{t('authenticatedAppView_wrongSubdomain_message')}</Text>
          </Callout>
          {expectedUrl && (
            <div
              css={theme => ({
                display: 'flex',
                flexDirection: 'column',
                gap: theme.space.Space1,
              })}
            >
              <Text size="sm">
                {t('authenticatedAppView_wrongSubdomain_correctUrlLabel')}
              </Text>
              <Text>{expectedUrl}</Text>
            </div>
          )}
          <Button
            onClick={handleSignOut}
            label={t('authenticatedAppView_wrongSubdomain_signOutButton')}
          />
        </Card>
      </div>
    </>
  )
}
